export const GET_POKEMONS = "GET_POKEMONS";
export const SEARCH_POKEMON = "SEARCH_POKEMON";
export const GET_BY_ID = "GET_BY_ID";
export const FILTER_POKEMONS = "FILTER_POKEMONS";
export const CLEAN_POKEMONS = "CLEAN_POKEMONS";
export const GET_TYPES = "GET_TYPES";
export const SORT_BY_NAME = "SORT_BY_NAME";
export const SORT_BY_ATTACK = "SORT_BY_ATTACK";
export const CHANGE_PAGE = "CHANGE_PAGE";
export const POST_POKEMON = "POST_POKEMON";
